/*global FormController, WebView, moment*/
var customCriteriaPopupController = new FormController("iz_custom_criteria", 
    {
        directory: "views/customCriteria",
        name: "customCriteriaPopup",
        route: "custom-criteria",
        buttonsHTML: "<!-- no button -->",
        nocache: true, //no cache because the column field must be recompute for each screen
        openInPopup: true,
        noTitle: true,
        popup: {
            //size can by small, medium, large and wide
            size: "medium"
        },
        joinFetch: [
            { otherTable : "iz_custom_criteria_column", name: "lines", type:"2many" }
        ]
    }
);


//handle the opening parameters
customCriteriaPopupController.prepareDataOnEnter = function(data, callback){
    if(!data){
        data = { 
            tableName: window.currentScreenTable,
            screen_to_display: window.currentScreenName,
            lines : [] 
        } ; 
        (window.currentScreenCriterias||[]).forEach(function(criteria, i){
            var value1 = criteria.defaultValue;
            var value2 = criteria.defaultValue2;
            var computed_value = false;
            var value_computed2 = undefined;
            var value_computed1 = undefined;
            if(criteria.type === "between"){
                if(moment(value1).isValid()){
                    computed_value = true ;
                    var now = new moment().startOf("day") ;
                    var param = new moment(value1).startOf("day");
                    value_computed1 = "moment()" ;
                    if(param.diff(now, 'years')){
                        value_computed1 += ".add("+param.diff(now, 'years')+", 'years')" ;
                        now.add(param.diff(now, 'years'), 'years') ;
                    }
                    if(param.diff(now, 'months')){
                        value_computed1 += ".add("+param.diff(now, 'months')+", 'months')" ;
                        now.add(param.diff(now, 'months'), 'months') ;
                    }
                    if(param.diff(now, 'days')){
                        value_computed1 += ".add("+param.diff(now, 'days')+", 'days')" ;
                    }
                }
                if(moment(value2).isValid()){
                    computed_value = true ;
                    var now = new moment().startOf("day") ;
                    var param = new moment(value2).startOf("day") ;
                    value_computed2 = "moment()" ;
                    if(param.diff(now, 'years')){
                        value_computed2 += ".add("+param.diff(now, 'years')+", 'years')" ;
                        now.add(param.diff(now, 'years'), 'years') ;
                    }
                    if(param.diff(now, 'months')){
                        value_computed2 += ".add("+param.diff(now, 'months')+", 'months')" ;
                        now.add(param.diff(now, 'months'), 'months') ;
                    }
                    if(param.diff(now, 'days')){
                        value_computed2 += ".add("+param.diff(now, 'days')+", 'days')" ;
                    }
                }
            }
            WebView.fieldsSchema.getSchema()["iz_custom_criteria_column"].columns.some(function(column){
                if(column.name === "column"){
                    if(!column.values[criteria.field]){
                        column.values[criteria.field] = WebView.tr("fields."+(criteria.table||window.currentScreenTable)+"."+criteria.field);
                    }
                    return true;
                }
            }) ;
            data.lines.push({
                column: criteria.field,
                computed_value : computed_value,
                sequence: i,
                table: criteria.table,
                type: criteria.type,
                no_value: criteria.defaultValue === undefined || criteria.defaultValue === null,
                value1: criteria.defaultValue,
                value2: criteria.defaultValue2,
                value_computed : value_computed1,
                value_computed2 : value_computed2,
            }) ;
        }) ;
        return callback(null, data) ;
    }
    //receive an id, read the record from database
    this.api.db.iz_custom_criteria.searchFirst({id: data}, [
        { otherTable : "iz_custom_criteria_column", name: "lines", type:"2many"}
    ], function(err, record){
        if(err){ return callback(err) ;}
        record.lines.forEach(function(line){
            if(line.value1 && line.value1[0] === "[" && line.value1[line.value1.length-1] === "]"){
                line.value1 = JSON.parse(line.value1) ;
            }
            line.value_computed = line.value1 ;
            line.no_value = line.value1 === undefined || line.value1 === null ;
        }) ;
        record.tableName = window.currentScreenTable ;
        callback(null, record) ;
    }.bind(this)) ;
} ;

//the popup will never be in read mode, switch to create or modify
customCriteriaPopupController.onChangeMode = function(ev){
    if(ev.data === "read"){
        if(!this.data.id){
            this.setMode("create") ;
        }else{
            this.setMode("modify") ;
        }
    }
} ;

customCriteriaPopupController.onRender = function(){
    this.view.ensureDisplayed(function(){
        this.data.lines.forEach(function(line, i){
            if(line.column){
                var instance = this.view.views[Object.keys(this.view.views)[0]].instances[i] ;
                if(instance){
                    this.onColumn({source: instance}) ;
                }
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

customCriteriaPopupController.onColumn = function(ev){
    var line = ev.source.updateData() ;
    ev.source.EL.fieldValue1.innerHTML = "" ;
    if(!line.column){ return ; }
    if(!line.value1){
        line.no_value = true ;
    }
    var el = document.createElement("DIV") ;
    var el2 = document.createElement("DIV") ;
    ev.source.getElement(ev.source.EL.fieldValue1).appendChild(el) ;
    ev.source.getElement(ev.source.EL.fieldValue2).appendChild(el2) ;
    line.type = "single" ;
    var tableName = line.table || this.data.tableName ;
    WebView.fieldsSchema.getSchema()[tableName].columns.some(function(col){
        if(line.column === col.name){
            if(col.type === "date" || col.type === "timestamp" || col.type === "float8" || col.type === "int"){
                line.type = "between" ;
            }else if(col.type === "boolean" || col.type === "bool"){
                line.type = "boolean" ;
            }
            return true ;
        }
    }) ;
    this.view.longTask(function(done){
        ev.source.createFieldWithSchema(el, tableName, line.column, {statesAsSelection: true}, function(err){
            if(err){ return done(err) ; }
            ev.source.getElement(ev.source.EL.fieldValue1).getValue = el.getValue.bind(el) ;
            ev.source.getElement(ev.source.EL.fieldValue1).setValue = el.setValue.bind(el) ;
            ev.source.getElement(ev.source.EL.fieldValue1).setReadOnly = el.setReadOnly.bind(el) ;
            ev.source.createFieldWithSchema(el2, tableName, line.column, {statesAsSelection: true}, function(err){
                if(err){ return done(err) ; }
                ev.source.getElement(ev.source.EL.fieldValue2).getValue = el2.getValue.bind(el2) ;
                ev.source.getElement(ev.source.EL.fieldValue2).setValue = el2.setValue.bind(el2) ;
                ev.source.getElement(ev.source.EL.fieldValue2).setReadOnly = el2.setReadOnly.bind(el2) ;
                ev.source.render() ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

customCriteriaPopupController.onClose = function(){
    this.mode = 'read' ; //avoid abort input warning
};

//close when user click on cancel button
customCriteriaPopupController.onCancel = function(){
    this.view.close() ;
};

customCriteriaPopupController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    viewData.all_users = true ;
    viewData.lines.forEach(function(line, i){
        line.sequence = i ;
        if(line.computed_value){
            line.value1 = line.value_computed ;
            line.value2 = line.value_computed2 ;
        }
        if(line.no_value){
            line.value1 = null ;
            line.value2 = null ;
        }
    }) ;
    FormController.prototype.getRecordsToSave.call(this, viewData, dataBeforeModif, callback) ;
} ;

//save and close on validate
customCriteriaPopupController.onValidate = function(){
    this.view.longTask(function(done){
        this.doValidate(function(err, savedRecord){
            if(err){ return done(err); }
            if(!savedRecord){
                //check failed
                return done() ;
            }
            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            window.location.reload();
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

//save and close on validate
customCriteriaPopupController.onResetToDefault = function(){
    this.view.longTask(function(done){
        this.api.db.iz_custom_criteria.remove({id: this.data.id}, function(err){
            if(err){ return done(err); }

            this.mode = 'read' ; //avoid abort input warning
            this.view.close() ;
            window.location.reload();
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = customCriteriaPopupController ;